import { Trans } from '@lingui/macro'
import React from 'react'
import { InputField } from 'webbook-airways'

export default function InputFieldCity(props) {
  return (
    <InputField
      css={{ flex: 1 }}
      autoComplete="new-password"
      label={<Trans>City</Trans>}
      {...props}
    />
  )
}
